import Button from '../../../../../../components/generics/buttons/Button';
import useSignLease from '../../../context';
import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import classes from './index.module.scss';
import ConnectBankButton from '../../../../../../components/features/CTAs/ConnectBank/Button';

type Props = HTMLAttributes<HTMLDivElement>;
const SignLeaseActionButton = ({ className }: Props) => {
  const {
    hasBankConnection,
    onClickSign,
    signButtonActive,
    signButtonText,
    signing,
  } = useSignLease();
  return (
    <div className={classNames(classes.container, className)}>
      {hasBankConnection ? (
        <Button
          onClick={onClickSign}
          disabled={!signButtonActive || signing}
          loading={signing}
        >
          {signButtonText}
        </Button>
      ) : (
        <ConnectBankButton className={classes.buttonBlack} />
      )}
    </div>
  );
};

export default SignLeaseActionButton;
